import Cookies from 'js-cookie';
import * as Mutations from '../../mutations';

export default {
  setUser({ dispatch, commit, getters }, user) {
    commit(Mutations.SET_USER, user);

    dispatch(user && user.nightMode ? 'setDarkTheme' : 'setLightTheme');

    dispatch('setLanguage', (user && getters.getLanguage(user.language)) || getters.language);
    dispatch('setFontSize', user && user.fontSize);
  },
  setToken({ commit }, token) {
    if (token) {
      Cookies.set('token', token);
    } else {
      Cookies.remove('token');
    }
    commit(Mutations.SET_TOKEN, token);
  },
  recoverToken({ dispatch }) {
    const token = Cookies.get('token');
    if (token) {
      dispatch('setToken', token);
    }

    const refreshTokenExpiration = Cookies.get('refreshTokenExpiration');
    if (refreshTokenExpiration) {
      dispatch('setRefreshTokenExpiration', refreshTokenExpiration);
    }
  },
  setTemporaryAccessData({ commit }, data) {
    commit(Mutations.SET_TEMPORARY_ACCESS_DATA, data);
  },
  setRecoverData({ commit }, data) {
    commit(Mutations.SET_RECOVER_DATA, data);
  },
  clearRecoverData({ dispatch }) {
    dispatch('setRecoverData', null);
  },
  clearTemporaryAccessData({ dispatch }) {
    dispatch('setTemporaryAccessData', null);
  },
  setAccessPending({ commit }, pending) {
    commit(Mutations.SET_ACCESS_PENDING, pending);
  },
  removeAccessPending({ commit }, pending) {
    commit(Mutations.REMOVE_ACCESS_PENDING, pending);
  },
  clearAccessPending({ commit }) {
    commit(Mutations.CLEAR_ACCESS_PENDING);
  },
  setRefreshTokenExpired({ commit }, isExpired) {
    commit(Mutations.SET_REFRESH_TOKEN_EXPIRED, isExpired);
  },
  setRefreshTokenExpiration({ commit }, expiration) {
    if (expiration) {
      Cookies.set('refreshTokenExpiration', expiration);
    } else {
      Cookies.remove('refreshTokenExpiration');
    }
    commit(Mutations.SET_REFRESH_TOKEN_EXPIRATION, expiration);
  },
};
